// user-defined type guard. Can be used as a replacement
// for [].filter(Boolean) when filtering out null and undefined values.
function isDefined<T>(val: T | undefined | null): val is T {
    return val !== undefined && val !== null
}

export { isDefined }
